import pkg from './package.json' assert { type: 'json' };
import { Environment } from './app/types/enums/environment.enum';
import { FeatureName } from './app/types/enums/features.enum';

export const appEnv = process.env.NUXT_ENV || Environment.DEVELOPMENT;

interface EnvironmentSettings {
  siteEnvironment: string;
  apiBaseUrl: string;
  devtoolsEnabled: boolean;
  ssrEnabled: boolean;
  features: Record<FeatureName, boolean>;
  sentry: {
    tracesSampleRate: number;
    replaysSessionSampleRate: number;
    replaysOnErrorSampleRate: number;
    profilesSampleRate: number;
    releaseName: string;
    debug: boolean;
  };
}

interface IGlobalSettings {
  development: EnvironmentSettings;
  production: EnvironmentSettings;
  [key: string]: EnvironmentSettings;
}

const GlobalSettings: IGlobalSettings = {
  staging: {
    siteEnvironment: Environment.STAGING,
    apiBaseUrl: 'https://greenbow.dk',
    devtoolsEnabled: true,
    ssrEnabled: false,
    features: {
      [FeatureName.PRODUCT_MIGRATION]: false
    },
    sentry: {
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
      profilesSampleRate: 0.2,
      releaseName: `${pkg.name}-${Environment.STAGING}@${pkg.version}`,
      debug: false
    }
  },
  development: {
    siteEnvironment: Environment.DEVELOPMENT,
    apiBaseUrl: 'https://greenbow.dk',
    devtoolsEnabled: true,
    ssrEnabled: false,
    features: {
      [FeatureName.PRODUCT_MIGRATION]: false
    },
    sentry: {
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
      profilesSampleRate: 0.2,
      releaseName: `${pkg.name}-${Environment.DEVELOPMENT}@${pkg.version}`,
      debug: false
    }
  },
  production: {
    siteEnvironment: Environment.PRODUCTION,
    apiBaseUrl: 'https://greenbow.dk',
    devtoolsEnabled: false,
    ssrEnabled: true,
    features: {
      [FeatureName.PRODUCT_MIGRATION]: false
    },
    sentry: {
      tracesSampleRate: 0.3,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      profilesSampleRate: 0.2,
      releaseName: `${pkg.name}-${Environment.PRODUCTION}@${pkg.version}`,
      debug: false
    }
  }
};

export { GlobalSettings };
